import qs from 'qs';
import _ from 'lodash';
import request from '../../../../shared/lib/request';
import { API } from '../../../../shared/constants';

const getAgenzie = (page, noPagination) =>
  request({
    url: API.AGENZIA_KIRON,
    method: 'GET',
    params: {
      pagination: !noPagination,
      page: page || 1,
    },
  });

const getAgenzieByRA = (raId) =>
  request({
    url: API.AGENZIA_KIRON,
    method: 'GET',
    params: {
      pagination: false,
      filter: [
        raId && {
          type: 'eq',
          field: 'responsabilearea',
          value: raId,
        },
      ].filter((o) => o),
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getAgenzieWithSearch = ({ page, searchText, orderField, orderDirection }) => {
  const filter = [];

  if (searchText) {
    const fields = ['codice', 'nome', 'marchio'];

    fields.forEach((field) => {
      filter.push({
        type: 'like',
        field,
        value: `%${searchText}%`,
        where: 'or',
      });
    });
  }

  return request({
    url: `${API.AGENZIA_KIRON}`,
    method: 'GET',
    params: {
      page: page || 1,
      filter,
      'order-by': [
        {
          type: 'field',
          field: orderField && orderDirection !== 'none' ? orderField : 'updatedAt',
          direction: orderDirection !== 'none' && orderDirection ? orderDirection : 'desc',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });
};

const getAllAgenzie = (noPagination) =>
  request({
    url: API.AGENZIA_KIRON,
    method: 'GET',
    params: {
      pagination: !noPagination,
    },
  });

const getAgenzieByRAOptions = (raId) =>
  getAgenzieByRA(raId)
    .then((res) =>
      res._embedded.agenziakiron.map((obj) => ({ value: obj.id, label: `${obj.codice} - ${obj.descrizione}` }))
    )
    .then((data) => ({ options: data }));

const getAgenzieOptions = () =>
  getAgenzie(0, true)
    .then((res) =>
      res._embedded.agenziakiron.map((obj) => ({ value: obj.id, label: `${obj.codice} - ${obj.descrizione}` }))
    )
    .then((data) => ({ options: data }));

const getAgenzieOptionsCode = () =>
  getAgenzie(0, true)
    .then((res) =>
      res._embedded.agenziakiron.map((obj) => ({ value: obj.codice, label: `${obj.codice} - ${obj.descrizione}` }))
    )
    .then((data) => ({ options: data }));

const getAgenzieByRAOptionsValue = (raId) =>
  getAgenzieByRA(raId)
    .then((res) => {
      const options = [];

      res._embedded.agenziakiron.forEach((obj) => {
        const [code, number] = [obj.codice.slice(0, 1), obj.codice.slice(1)];
        const intNumber = _.toInteger(number);
        if (obj.attivo && code === 'k' && intNumber < 1000) {
          options.push({ key: obj.id, value: obj.id, text: `${obj.codice} - ${obj.descrizione}` });
        }
      });

      const orderedArray = _.orderBy(options, ['text']);
      return [{ key: '-', value: '', text: '--' }].concat(orderedArray);
    })
    .then((data) => ({ options: data }));

const delAgenzia = (id) =>
  request({
    url: `${API.AGENZIA_KIRON}/${id}`,
    method: 'DELETE',
  });

const create = (content) =>
  request({
    url: API.AGENZIA_KIRON,
    method: 'POST',
    data: content,
  });

const put = (content) =>
  request({
    url: `${API.AGENZIA_KIRON}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const patch = (id, data) =>
  request({
    url: `${API.AGENZIA_KIRON}/${id}`,
    method: 'PATCH',
    data,
  });

const patchPubblicazioneWeb = (id, abilitaPubblicazioneWeb) =>
  patch(id, { abilitaPubblicazioneWeb });

const AgenziaKironService = {
  getAgenzie,
  getAllAgenzie,
  getAgenzieOptions,
  getAgenzieOptionsCode,
  getAgenzieWithSearch,
  getAgenzieByRA,
  getAgenzieByRAOptions,
  getAgenzieByRAOptionsValue,
  delAgenzia,
  create,
  put,
  patch,
  patchPubblicazioneWeb,
};

export default AgenziaKironService;



// WEBPACK FOOTER //
// ./app/shared/services/api/agenziakiron/index.js